import { useState } from "react";
import Drower from "./Drower";

function Settings() {
  const [visibleSettings, setVisibleSettings] = useState(false)

  const changeLanguage = (lang) => {
    localStorage.setItem('language', lang)
    // if(lang == 'fa'){
    //   document.documentElement.style.setProperty('--font-family',"'iran-sans', sans-serif")
    // }
    // if(lang == 'en'){
    //   document.documentElement.style.setProperty('--font-family',"'Rubik', sans-serif")
    // }
    window.location.reload()
  }

  const changeRootColor = (id) => {
    if (id == 1) {
      document.documentElement.style.setProperty('--main-color1', "#ff3456")
      document.documentElement.style.setProperty('--main-color2', "#ff99aa")
      document.documentElement.style.setProperty('--main-shadow', "#ff345671")
    }
    else if (id == 2) {
      document.documentElement.style.setProperty('--main-color1', "#f12711")
      document.documentElement.style.setProperty('--main-color2', "#f5af19")
      document.documentElement.style.setProperty('--main-shadow', "#f127118e")
    }
    else if (id == 3) {
      document.documentElement.style.setProperty('--main-color1', "#0083B0")
      document.documentElement.style.setProperty('--main-color2', "#1ac6ff")
      document.documentElement.style.setProperty('--main-shadow', "#0084b094")
    }
    else if (id == 4) {
      document.documentElement.style.setProperty('--main-color1', "#11998e")
      document.documentElement.style.setProperty('--main-color2', "#38ef7d")
      document.documentElement.style.setProperty('--main-shadow', "#11998e9f")
    }
    else if (id == 5) {
      document.documentElement.style.setProperty('--main-color1', "#262626")
      document.documentElement.style.setProperty('--main-color2', "#666666")
      document.documentElement.style.setProperty('--main-shadow', "#2626267e")
    }
    else if (id == 6) {
      document.documentElement.style.setProperty('--main-color1', "#8c8c8c")
      document.documentElement.style.setProperty('--main-color2', "#a6a6a6")
      document.documentElement.style.setProperty('--main-shadow', "#8c8c8c86")
    }
  }

  return (
    <>
      <div className="settins" onClick={() => { setVisibleSettings(true) }}>
        <img src="/assets/svg/cog.svg" alt="svg" />
      </div>

      <Drower name={localStorage.getItem('language') == 'fa' ? 'تنظیمات' : 'Setting'} title={'show-p-setting'} visible={visibleSettings} setVisible={setVisibleSettings}>
        <div className="setting-item">
          <span>{localStorage.getItem('language') == 'fa' ? 'انتخاب رنگ' : 'Select color'}</span>
          <div className="setting-item-color">
            <div className="setting-item-color-item" onClick={() => changeRootColor(1)} />
            <div className="setting-item-color-item" onClick={() => changeRootColor(2)} />
            <div className="setting-item-color-item" onClick={() => changeRootColor(3)} />
            <div className="setting-item-color-item" onClick={() => changeRootColor(4)} />
            <div className="setting-item-color-item" onClick={() => changeRootColor(5)} />
            <div className="setting-item-color-item" onClick={() => changeRootColor(6)} />

          </div>
        </div>
        <div className="setting-item">
          <span>{localStorage.getItem('language') == 'fa' ? 'انتخاب زبان' : 'Select Language'}</span>
          <div className="setting-item-language">
            <div className="setting-item-language-item" onClick={() => changeLanguage('fa')} >Fa</div>
            <div className="setting-item-language-item" onClick={() => changeLanguage('en')}>En</div>
          </div>
        </div>
        <div className="drower-close" onClick={() => { setVisibleSettings(false) }}>
          {localStorage.getItem('language') == 'fa' ? 'بستن' : 'Close'}
        </div>
      </Drower>
    </>
  );
}

export default Settings;